
import {KeyValuePair} from '../common/key-value-pair';
import { StringStringKeyValuePair } from './StringStringKeyValuePair';


export interface SearchDataRequest {
  searchText: string;
  searchFilters: KeyValuePair<any>;
  importantFilters: KeyValuePair<any>;
  staticFilters: KeyValuePair<any>;
  pageNr: number;
  pageSize: number;
  sortField: string;
  sortAsc: boolean;
  barcodeSearch: boolean;
  facets?: StringStringKeyValuePair[], 
  searchMode?: SearchModeEnum;
}

export type SearchModeEnum = 'All' | 'Any';

export const SearchModeEnum = {
    All: 'All' as SearchModeEnum,
    Any: 'Any' as SearchModeEnum
};